import { render, staticRenderFns } from "./refundDialog.vue?vue&type=template&id=504c0cf2"
import script from "./refundDialog.vue?vue&type=script&lang=js"
export * from "./refundDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports